export default {
  name: 'AppVersion',

  data() {
    return {
      version: process.env.APP_VERSION,
    };
  },
};
